<script setup lang="ts">

defineExpose({
  open,
  close
});

const router = useRouting();
const { t } = useEkI18n();
const fileUploadStore = useFileUploadStore();

const isOpen = ref(false);

const queue = computed(() => {
  return fileUploadStore.queue;
});

const uploadedQueue = computed(() => {
  return [...fileUploadStore.uploadedQueue].reverse();
});

function open() {
  fileUploadStore.removeOldUploadedFiles();
  isOpen.value = true;
}

function close() {
  isOpen.value = false;
}

function isProjectUpload(file: UploadMetaData): file is ProjectUploadMetadata {
  return 'uploadType' in file && file.uploadType === 'project';
}

function isQAUpload(file: UploadMetaData): file is QAUploadMetadata {
  return 'uploadType' in file && file.uploadType === 'qa';
}

function goToWorksheet(message: UploadMetaData) {
  if (!message.worksheetId || !message.projectId) return;

  if (isProjectUpload(message)) {
    router.replace(`/worksheets/${message.worksheetId}`, true);
  } else if (isQAUpload(message)) {
    router.replace(`/worksheets/${message.worksheetId}/qa`, true);
  }

  close();
}
</script>

<template>
  <Modal
    v-model:open="isOpen"
    animation-direction="vertical"
    :title="t('uploads.title')"
    :close-override="close"
  >
    <IonContent>
      <IonListHeader v-if="queue.length">
        {{ t("uploads.pendingUploads") }}
      </IonListHeader>
      <IonList>
        <DocumentsUploadItem
          v-for="file in queue"
          :key="file.filePath"
          :file="file"
          :show-go-to-button="true"
          @goto="goToWorksheet"
          @retry-file="fileUploadStore.retry(file)"
        />
      </IonList>
      <IonListHeader v-if="uploadedQueue.length">
        {{ t("uploads.completedUploads") }}
      </IonListHeader>
      <IonList>
        <DocumentsUploadItem
          v-for="file in uploadedQueue"
          :key="file.filePath"
          :file="file"
          :show-go-to-button="true"
          @goto="goToWorksheet"
        />
      </IonList>
    </IonContent>
  </Modal>
</template>
